import { useEffect, useState } from "react";

export function usePrecios() {
  const [precios, setPrecios] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const controller = new AbortController();
    const baseUrl = process.env.PUBLIC_URL || "";
    const cacheBuster = Date.now();

    const fetchJson = async (url) => {
      const response = await fetch(url, {
        cache: "no-store",
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`No se pudo cargar ${url} (${response.status})`);
      }

      return response.json();
    };

    const loadPrices = async () => {
      try {
        return await fetchJson(`/api/precios?t=${cacheBuster}`);
      } catch {
        return fetchJson(`${baseUrl}/config/precios.json?t=${cacheBuster}`);
      }
    };

    loadPrices()
      .then((response) => {
        setPrecios(response);
        setError(null);
      })
      .catch((err) => {
        if (err.name === "AbortError") return;
        setError(err);
      });

    return () => controller.abort();
  }, []);

  return { precios, error };
}
